export const sidebarConstants = {
	DRAWER_CLOSE: 'DRAWER_CLOSE',
	DRAWER_OPEN: 'DRAWER_OPEN',
	SIDEBAR_IS_LOGS_OPEN: 'SIDEBAR_IS_LOGS_OPEN'
};
